import http from 'conversations-http/clients/http';
export const fetchHistoryMessageById = ({
  messageId,
  threadId
}) =>
// NOTE - This type is not entirely accurate, this endpoint can technically return any of the message types listed in the schema below
// https://tools.hubteam.com/api-catalog/services/cv-threads-service/v1/spec/internal#operations-Message-get-%2Fconversations-threads%2Fv1%2Fmessage%2F%7BthreadId%7D%2F%7BconversationMessageId%7D
http.get(`conversations-threads/v1/message/${threadId}/${messageId}`);